module.exports = __webpack_public_path__ + "media/images/brand/app_symbol_250-83d45c149a914cc66d6c2bb45cb56196.png";